// Module
var code = "<react-component name=\"MergeContact\"></react-component>\n";
// Exports
module.exports = code;